import React from "react";
import { Checkbox, Divider } from "antd";
import type { LeadingZeroesFlags } from "./leadingZeroesApi";

interface LeadingZeroesFlagsEditorProps {
  value: LeadingZeroesFlags;
  onChange: (next: LeadingZeroesFlags) => void;
  disabled?: boolean;
  /** Why the boxes are not editable, or what they mean right now. */
  note?: string;
  /** When true, the boxes stay locked until the user opts in to replacing the record. */
  optIn?: boolean;
  optedIn?: boolean;
  onOptInChange?: (next: boolean) => void;
}

const FLAG_LABELS: [keyof LeadingZeroesFlags, string][] = [
  ["fromDeviceSerial", "From Device Serial"],
  ["refreshAll", "Refresh All"],
  ["setOneBit", "Set One Bit"],
  ["reinitializeAllDevices", "Reinitialize All Devices"],
  ["setOneByte", "Set One Byte"],
  ["rvu", "RVU"],
  ["rvuHeartbeat", "RVU Heart Beat"],
];

function LeadingZeroesFlagsEditor({
  value,
  onChange,
  disabled = false,
  note = "",
  optIn = false,
  optedIn = false,
  onOptInChange = undefined,
}: LeadingZeroesFlagsEditorProps) {
  return (
    <>
      <Divider orientation="left" plain>
        Leading Zeroes Expected
      </Divider>
      {note && <div className="mb-2">{note}</div>}
      {optIn && (
        <div className="mb-2">
          <Checkbox
            data-testid="lz-opt-in"
            checked={optedIn}
            onChange={(e) => onOptInChange?.(e.target.checked)}
          >
            Set custom leading zeroes for this adapter
          </Checkbox>
        </div>
      )}
      <div className="row">
        {FLAG_LABELS.map(([key, label]) => (
          <div className="col-12 col-md-4 mt-2" key={key}>
            <Checkbox
              data-testid={`lz-flag-${key}`}
              checked={value[key]}
              disabled={disabled || (optIn && !optedIn)}
              onChange={(e) => onChange({ ...value, [key]: e.target.checked })}
            >
              {label}
            </Checkbox>
          </div>
        ))}
      </div>
    </>
  );
}

export default LeadingZeroesFlagsEditor;
